/**
 * Helpers for the schema-driven inspection form.
 * Schema is fetched from /api/checklist/schema and cached.
 */
export const isVisible = (item, items) => {
  const cond = item.show_if;
  if (!cond) return true;
  const target = (items[cond.field] || {}).answer || "";
  if ("equals" in cond) return target === cond.equals;
  if ("in" in cond) return cond.in.includes(target);
  if ("not_in" in cond) return !cond.not_in.includes(target);
  return true;
};

export const fileToDataUrl = (file) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });

export const stampTimestamp = (ctx, w, h, when = new Date()) => {
  // Burn an evidence-grade date/time watermark into the bottom-right corner.
  const label = when.toLocaleString(undefined, {
    day: "2-digit", month: "short", year: "numeric",
    hour: "numeric", minute: "2-digit",
  });
  const fs = Math.max(14, Math.round(Math.min(w, h) * 0.032));
  ctx.font = `bold ${fs}px Arial, sans-serif`;
  const tw = ctx.measureText(label).width;
  const pad = Math.round(fs * 0.5);
  const bx = w - tw - pad * 2 - 8, by = h - fs - pad * 2 - 8;
  ctx.fillStyle = "rgba(15, 23, 42, 0.62)";
  ctx.fillRect(bx, by, tw + pad * 2, fs + pad * 2);
  ctx.fillStyle = "#5EEAD4";
  ctx.textBaseline = "middle";
  ctx.fillText(label, bx + pad, by + pad + fs / 2);
};

export const downscaleImage = async (file, maxDim = 1400, quality = 0.78, stamp = true) => {
  // Optional client-side compression so photos don't blow up the document
  const bitmap = await createImageBitmap(file).catch(() => null);
  if (!bitmap) return fileToDataUrl(file);
  const { width, height } = bitmap;
  const scale = Math.min(1, maxDim / Math.max(width, height));
  const w = Math.round(width * scale);
  const h = Math.round(height * scale);
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0, w, h);
  // Gallery uploads: file.lastModified is the closest thing to capture time
  if (stamp) stampTimestamp(ctx, w, h, file.lastModified ? new Date(file.lastModified) : new Date());
  return canvas.toDataURL("image/jpeg", quality);
};
